import React from "react";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import TransferItem from "./TransferItem";
import Loader from "../../../ui/shared/Loader/Loader";
import {Alert} from "../../../ui/shared/Alert/Alert";
import {useTransferMeSearchData} from "../../hooks/useTransferMeSearchData";
import TransferMeSearchForm from "../searchForm/TransferMeSearchForm";
import {Link} from "react-router-dom";

const TransferList = () => {
    const t = useTranslate();
    const {data: transfers, loading, fetchData} = useTransferMeSearchData();


    return (
        <div
            className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
            <h2 className="text-3xl lg:text-4xl font-semibold">
                {t("mainNav.transfers") || "Transfers"}
            </h2>
            <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
            <TransferMeSearchForm onSearch={fetchData} transfers={transfers}/>
            <div>
                {loading && <Loader centerHorizontally/>}
                {!loading && transfers.length === 0 && <Alert type="info" closable={false}>{t("transfers.message.noTransfers")}</Alert>}
                {!loading && transfers.length > 0 && transfers.map((transfer) => (
                    <Link
                        key={transfer.id}
                        to={`/transfer/${transfer.uuid}`}
                        className="block mb-4"
                    >
                        <TransferItem item={transfer}/>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default TransferList;
